// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer vierkant {
  v-top-bar .item {
    padding: 0.5rem 0;
    border-bottom: 1px solid var(--gc-border-color);
    min-width: 10rem;
  }
  v-top-bar .error-message {
    color: var(--gc-color-danger);
    padding: 0.5rem 0;
    font-size: 0.9rem;
  }
  v-top-bar .info {
    background: var(--gc-color-info);
    border: 1px solid var(--gc-color-info-shade);
    border-radius: 3px;
    width: 100%;
    max-width: 300px;
    padding: 0.45rem 0.75rem;
    display: flex;
    gap: 0.5rem;
    cursor: pointer;
    color: var(--gc-color-info-contrast);
  }
  @media screen and (max-width: 850px) {
    v-top-bar .info {
      max-width: 42px;
    }
    v-top-bar .info .text {
      display: none;
      color: var(--gc-color-info-contrast);
    }
  }
  v-top-bar .overflow-visible {
    overflow: visible;
  }
  v-top-bar .p-toolbar-group-right {
    display: flex;
  }
  v-top-bar .user-info {
    margin-left: 1rem;
    text-align: left;
  }
  v-top-bar .user-info .name {
    font-size: 1rem;
    font-weight: 600;
  }
  v-top-bar .user-image {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    border: 1px solid darkgrey;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-top-bar/v-top-bar.component.sass"],"names":[],"mappings":"AAAA;EAEQ;IACI,iBAAA;IACA,+CAAA;IACA,gBAAA;EAAV;EAEM;IACI,6BAAA;IACA,iBAAA;IACA,iBAAA;EAAV;EAEM;IACI,gCAAA;IACA,4CAAA;IACA,kBAAA;IACA,WAAA;IACA,gBAAA;IACA,wBAAA;IACA,aAAA;IACA,WAAA;IACA,eAAA;IACA,oCAAA;EAAV;EAGM;IACI;MAII,eAAA;IAJZ;IACY;MACI,aAAA;MACA,oCAAA;IAChB;EACF;EAEM;IACI,iBAAA;EAAV;EAEM;IACI,aAAA;EAAV;EAEM;IACI,iBAAA;IACA,gBAAA;EAAV;EACU;IACI,eAAA;IACA,gBAAA;EACd;EAAM;IACI,aAAA;IACA,cAAA;IACA,kBAAA;IACA,0BAAA;EAEV;AACF","sourcesContent":["@layer vierkant\n    v-top-bar\n        .item\n            padding: 0.5rem 0\n            border-bottom: 1px solid var(--gc-border-color)\n            min-width: 10rem\n\n        .error-message\n            color: var(--gc-color-danger)\n            padding: 0.5rem 0 \n            font-size: 0.9rem\n\n        .info\n            background: var(--gc-color-info)\n            border: 1px solid var(--gc-color-info-shade)\n            border-radius: 3px\n            width: 100%\n            max-width: 300px\n            padding: 0.45rem 0.75rem \n            display: flex\n            gap: 0.5rem\n            cursor: pointer\n            color: var(--gc-color-info-contrast)\n\n\n        @media screen and (max-width: 850px)\n            .info\n                .text\n                    display: none\n                    color: var(--gc-color-info-contrast)\n                max-width: 42px\n\n\n        .overflow-visible\n            overflow: visible\n\n        .p-toolbar-group-right\n            display: flex\n\n        .user-info\n            margin-left: 1rem\n            text-align: left\n            .name\n                font-size: 1rem\n                font-weight: 600\n        .user-image\n            width: 1.5rem\n            height: 1.5rem\n            border-radius: 50%\n            border: 1px solid darkgrey\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
